import { Checkbox as MuiCheckbox } from '@mui/material';
import { CheckboxProps } from './Checkbox.props';
import { forwardRef } from 'react';

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ indeterminate, ...props }, ref) => {
    return (
      <MuiCheckbox
        ref={ref}
        indeterminate={indeterminate}
        slotProps={{
          input: {
            ...props.slotProps?.input,
            // Ensure indeterminate is set on the actual input element
            ref: (inputElement: HTMLInputElement | null) => {
              if (inputElement && indeterminate !== undefined) {
                inputElement.indeterminate = indeterminate;
              }
            },
          },
        }}
        {...props}
      />
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
